import { toDay } from "./dayjsHelper";

export const setFilterDateSunburst = (childrens = [], currentYear = toDay().dayFormatYear) => {
	const dataSunburs = childrens.map(({ children, ...rest }) => {
		const newChild = children.map((item) => {
			const { dates } = item;
			const count = dates.reduce((acc, val) => (val === currentYear ? acc + 1 : acc), 0);
			return {
				...item,
				count,
			};
		});
		return {
			...rest,
			children: newChild,
		};
	});
	const countChildren = dataSunburs.filter((data) => {
		const { children } = data;
		var allCero = children.every(function (elemento) {
			return elemento.count === 0;
		});
		return !allCero;
	});
	return { dataSunburs: countChildren };
};

export const setFilterDatePieChart = (datas = [], currentYear = toDay().dayFormatYear) => {
	const dataPie = datas.map(({ projects, ...rest }) => {
		const newValue = projects.reduce((acc, val) => (val === currentYear ? acc + 1 : acc), 0);
		return {
			...rest,
			value: newValue,
			projects,
		};
	});
	return { dataPie };
};
